import { render, staticRenderFns } from "./conditional-node.vue?vue&type=template&id=2480d482&scoped=true"
import script from "./conditional-node.vue?vue&type=script&lang=js"
export * from "./conditional-node.vue?vue&type=script&lang=js"
import style0 from "./conditional-node.vue?vue&type=style&index=0&id=2480d482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480d482",
  null
  
)

export default component.exports